import { render, staticRenderFns } from "./Detalles.vue?vue&type=template&id=e065caf0&"
import script from "./Detalles.vue?vue&type=script&lang=js&"
export * from "./Detalles.vue?vue&type=script&lang=js&"
import style0 from "./Detalles.vue?vue&type=style&index=0&id=e065caf0&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports